<template>
    <div>

      <section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-cyan" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Verifikasi Instrumen Guru</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-orange btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th style="width: 20%">Nama Responden</th>
                            <th style="width: 20%">Jabatan</th>
                            <th style="width: 30%">Sekolah</th>
                            <th style="width: 10%">Status</th>
                            <th style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                            <td class="text-center" :style="cekStatus(data.status)">{{index+1}}.</td>
                            <td>{{data.profile_id.profile.nama}}</td>
                            <td>{{data.profile_id.profile.jabatan}}</td>
                            <td>{{data.sekolah.type}} {{data.sekolah.status}} {{data.sekolah.sekolah}}</td>
                            <td>{{data.status}}</td>
                            <td class="text-center" >
                              <button class="btn bg-light-blue btn-xs waves-effect" @click="viewData(data.data_id)" title="Lihat Data" data-toggle="modal" data-target="#m_lihat_data">
                                  <i class="material-icons" >search</i>
                              </button>
                              <button class="btn bg-light-green btn-xs waves-effect" @click="viewId(data.data_id)" title="Setujui Data" data-toggle="modal" data-target="#m_setujui_data">
                                  <i class="material-icons" >done</i>
                              </button>
                              <button class="btn bg-red btn-xs waves-effect" @click="viewId(data.data_id)" title="Kembalikan Data" data-toggle="modal" data-target="#m_kembalikan_data">
                                  <i class="material-icons" >clear</i>
                              </button>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>

                      <span style="font-size: 85%; color: #a5a5a5"><b>{{page_first}} - {{page_last}}</b></span>

                      <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL SETUJUI xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_setujui_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <div class="modal-body">

                                  <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                      <label for="kode">Saran Petugas</label>
                                    </div>
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="form-line">
                                          <textarea rows="4" v-model="saran" class="form-control no-resize" placeholder="Isi dengan keterangan penilaian anda..."></textarea>
                                        </div>
                                      </div>
                                    </div>
                                  </div>



                                </div>
                                <div class="modal-footer">
                                    <button type="button" @click="setujuiData" class="btn btn-success waves-effect">SETUJUI</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">BATAL</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL SETUJUI xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL KEMBALIKAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_kembalikan_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-deep-orange">
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <div class="modal-body">

                                  <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                      <label for="kode">Saran Petugas</label>
                                    </div>
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="form-line">
                                          <textarea rows="4" v-model="saran" class="form-control no-resize" placeholder="Isi dengan keterangan pengembalian anda..."></textarea>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" @click="kembalikanData" class="btn bg-deep-orange waves-effect">KEMBALIKAN</button>
                                    <button type="button" class="btn bg-red waves-effect" data-dismiss="modal">BATAL</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL KEMBALIKAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <h4 class="modal-title" id="largeModalLabel">DETIL DATA</h4>
                                </div>
                                <div class="modal-body">


                                  <div class="table-responsive">
                                    <table class="table table-bordered table-striped" style="width: 100%">
                                        <thead>
                                          <tr class="bg-info">
                                            <th style="width: 5%"></th>
                                            <th style="width: 95%"></th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                              <td class="text-center">1.</td>
                                              <td>
                                                Apakah program BOS disosialisasikan kepada masyarakat lingkungan sekolah Saudara? <br> <br>
                                                <div class="demo-radio-button">
                                                  <input name="group1" type="radio" id="radio_1" class="with-gap" v-model="soal_1" value="ya" disabled><label for="radio_1">Ya</label>
                                                  <input name="group1" type="radio" id="radio_2" class="with-gap" v-model="soal_1" value="tidak" disabled><label for="radio_2">Tidak</label>
                                                </div>
                                                <br>
                                                Jika Jawaban pada poin 1 Ya, Kapan dilaksanakannya? <br><br>
                                                <div class="demo-radio-button">

                                                  <input name="group_1_1" type="radio" id="radio_3" class="with-gap" v-model="soal_1_1" value="Dalam rapat rutin dihadiri guru" disabled><label for="radio_3">Dalam rapat rutin dihadiri guru</label> <br>
                                                  <input name="group_1_1" type="radio" id="radio_4" class="with-gap" v-model="soal_1_1" value="Dalam rapat khusus dihadiri anggota komite" disabled><label for="radio_4">Dalam rapat khusus dihadiri anggota komite</label> <br>
                                                  <input name="group_1_1" type="radio" id="radio_5" class="with-gap" v-model="soal_1_1" value="Dalam upacara bendera sekolah diikuti siswa dan guru" disabled><label for="radio_5">Dalam upacara bendera sekolah diikuti siswa dan guru</label> <br>
                                                  <input name="group_1_1" type="radio" id="radio_6" class="with-gap" v-model="soal_1_1" value="Dalam rapat khusus dihadiri orang tua/wali siswa" disabled><label for="radio_6">Dalam rapat khusus dihadiri orang tua/wali siswa</label>

                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">2.</td>
                                              <td>
                                                Selain dana BOS, apakah terdapat sumber dana lain untuk mendukung operasional sekolah Saudara? <br> <br>
                                                <div class="demo-radio-button">
                                                  <input name="group2" type="radio" id="radio_7" class="with-gap" v-model="soal_2" value="ya" disabled><label for="radio_7">Ya</label>
                                                  <input name="group2" type="radio" id="radio_8" class="with-gap" v-model="soal_2" value="tidak" disabled><label for="radio_8">Tidak</label>
                                                </div>

                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">3.</td>
                                              <td>
                                                Jika Jawaban pada poin 2 Ada, bersumber darimana dana tersebut? <br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group3" type="radio" id="radio_9" class="with-gap" v-model="soal_3" value="APBN" disabled><label for="radio_9">APBN</label> <br>
                                                  <input name="group3" type="radio" id="radio_10" class="with-gap" v-model="soal_3" value="APBD Provinsi" disabled><label for="radio_10">APBD Provinsi</label> <br>
                                                  <input name="group3" type="radio" id="radio_11" class="with-gap" v-model="soal_3" value="APBD Kabupaten/Kota" disabled><label for="radio_11">APBD Kabupaten/Kota</label> <br>
                                                  <input name="group3" type="radio" id="radio_12" class="with-gap" v-model="soal_3" value="Komite Sekolah" disabled><label for="radio_12">Komite Sekolah</label> <br>
                                                  <input name="group3" type="radio" id="radio_13" class="with-gap" v-model="soal_3" value="Lainnya" disabled><label for="radio_13">Lainnya</label>

                                                  </div>

                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input type="text" class="form-control" v-model="ket_3" placeholder="Jika Jawaban pada poin 3 'Lainnya', Sebutkan " disabled>
                                                    </div>
                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">4.</td>
                                              <td>
                                                Apakah selama periode April – Juni  2017 sekolah menerima pembayaran uang sekolah dari siswa? <br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group4" type="radio" id="radio_14" class="with-gap" v-model="soal_4" value="ya" disabled><label for="radio_14">Ya</label>
                                                  <input name="group4" type="radio" id="radio_15" class="with-gap" v-model="soal_4" value="tidak" disabled><label for="radio_15">Tidak</label>
                                                </div>
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input type="text" id="nilai" class="form-control" v-model="ket_4" placeholder="Jika Jawaban pada poin 4 Ya, Sebutkan " disabled>
                                                    </div>
                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">5.</td>
                                              <td>
                                                Apakah alokasi dana BOS dituangkan dalam RAPBS? <br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group5" type="radio" id="radio_16" class="with-gap" v-model="soal_5" value="Ada" disabled><label for="radio_16">Ada</label>
                                                  <input name="group5" type="radio" id="radio_17" class="with-gap" v-model="soal_5" value="tidak" disabled><label for="radio_17">Tidak</label>
                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">6.</td>
                                              <td>
                                                Siapa yang hadir dalam rapat pembahasan pemanfaatan dana BOS selain Kepala Sekolah? <br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group6" type="radio" id="radio_18" class="with-gap" v-model="soal_6" value="Wakil Kepala Sekolah" disabled><label for="radio_18">Wakil Kepala Sekolah</label>
                                                  <input name="group6" type="radio" id="radio_19" class="with-gap" v-model="soal_6" value="Ketua Komite Sekolah" disabled><label for="radio_19">Ketua Komite Sekolah</label>
                                                  <input name="group6" type="radio" id="radio_20" class="with-gap" v-model="soal_6" value="Bendahara Pengelola dana BOS" disabled><label for="radio_20">Bendahara Pengelola dana BOS</label>
                                                  <input name="group6" type="radio" id="radio_21" class="with-gap" v-model="soal_6" value="Perwakilan Guru" disabled><label for="radio_21">Perwakilan Guru</label>
                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">7.</td>
                                              <td>
                                                Apakah rencana pemanfaatan dana BOS meliputi kegiatan di bawah ini <br><br>

                                                <div class="demo-checkbox">
                                                  <input type="checkbox" id="basic_checkbox_1" class="filled-in" v-model="soal_7_1" disabled><label for="basic_checkbox_1">Pengembangan Perpustakaan</label> <br>
                                                  <input type="checkbox" id="basic_checkbox_2" class="filled-in" v-model="soal_7_2" disabled><label for="basic_checkbox_2">Kegiatan dalam rangka penerimaan peserta didik baru</label><br>
                                                  <input type="checkbox" id="basic_checkbox_3" class="filled-in" v-model="soal_7_3" disabled><label for="basic_checkbox_3">Kegiatan Pem-belajaran dan Ekstrakurikuler peserta didik</label><br>
                                                  <input type="checkbox" id="basic_checkbox_4" class="filled-in" v-model="soal_7_4" disabled><label for="basic_checkbox_4">Kegiatan Ulangan dan Ujian</label><br>
                                                  <input type="checkbox" id="basic_checkbox_5" class="filled-in" v-model="soal_7_5" disabled><label for="basic_checkbox_5">Pembelian bahan-bahan habis pakai</label><br>
                                                  <input type="checkbox" id="basic_checkbox_6" class="filled-in" v-model="soal_7_6" disabled><label for="basic_checkbox_6">Langganan daya dan jasa</label><br>
                                                  <input type="checkbox" id="basic_checkbox_7" class="filled-in" v-model="soal_7_7" disabled><label for="basic_checkbox_7">Perawatan sekolah</label><br>
                                                  <input type="checkbox" id="basic_checkbox_8" class="filled-in" v-model="soal_7_8" disabled><label for="basic_checkbox_8">Pembayaran honorarium bulanan guru honorer dan tenaga kependidikan honorer</label><br>
                                                  <input type="checkbox" id="basic_checkbox_9" class="filled-in" v-model="soal_7_9" disabled><label for="basic_checkbox_9">Pengembangan Profesi Guru</label><br>
                                                  <input type="checkbox" id="basic_checkbox_10" class="filled-in" v-model="soal_7_10" disabled><label for="basic_checkbox_10">Membantu siswa miskin</label><br>
                                                  <input type="checkbox" id="basic_checkbox_11" class="filled-in" v-model="soal_7_11" disabled><label for="basic_checkbox_11">Pembiayaan Pengelolaan dana BOS</label><br>
                                                  <input type="checkbox" id="basic_checkbox_12" class="filled-in" v-model="soal_7_12" disabled><label for="basic_checkbox_12">Pembelian dan perawatan perangkat computer</label><br>
                                                  <input type="checkbox" id="basic_checkbox_13" class="filled-in" v-model="soal_7_13" disabled><label for="basic_checkbox_13">Biaya lainnya apabila kebutuhan diatas sudah terpenuhi</label><br>
                                                </div>
                                                <i style="font-size:85%">* (Jawaban pilihan bisa lebih dari satu) *</i>

                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">8.</td>
                                              <td>
                                                Apakah Saudara mengetahui Bendahara Pengelola dana BOS membuat Buku Kas Umum, Buku Pajak dan PNBP (Penerimaan Negara Bukan Pajak) atas penerimaan pajak dan PNBP dana BOS tersendiri? <br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group8" type="radio" id="radio_22" class="with-gap" v-model="soal_8" value="Ya" disabled><label for="radio_22">Ya</label>
                                                  <input name="group8" type="radio" id="radio_23" class="with-gap" v-model="soal_8" value="tidak" disabled><label for="radio_23">Tidak</label>
                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">9.</td>
                                              <td>
                                                Apakah pernah ada lembaga pengawas berkompeten melaksanakan pengawasan atas pelaksanaan Program dana BOS? <br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group9" type="radio" id="radio_24" class="with-gap" v-model="soal_9" value="Pernah" disabled><label for="radio_24">Pernah</label>
                                                  <input name="group9" type="radio" id="radio_25" class="with-gap" v-model="soal_9" value="Belum" disabled><label for="radio_25">Belum</label>
                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">10.</td>
                                              <td>
                                                Apakah sekolah menerima pengaduan masyarakat terkait pelaksanaan program BOS? <br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group10" type="radio" id="radio_26" class="with-gap" v-model="soal_10" value="Ya" disabled><label for="radio_26">Ya</label>
                                                  <input name="group10" type="radio" id="radio_27" class="with-gap" v-model="soal_10" value="tidak" disabled><label for="radio_27">Tidak</label>
                                                </div>
                                              </td>
                                          </tr>
                                          <tr class="h_isitable">
                                              <td class="text-center">11.</td>
                                              <td>
                                                Apakah Saudara terlibat dalam penyusunan Laporan Akhir Pelaksanaan Program BOS? <br><br>
                                                <div class="demo-radio-button">
                                                  <input name="group11" type="radio" id="radio_28" class="with-gap" v-model="soal_11" value="Ya" disabled><label for="radio_28">Ya</label>
                                                  <input name="group11" type="radio" id="radio_29" class="with-gap" v-model="soal_11" value="tidak" disabled><label for="radio_29">Tidak</label>
                                                </div>
                                              </td>
                                          </tr>

                                          <tr class="h_isitable">
                                              <td class="text-center"></td>
                                              <td>
                                                <br>
                                                <i>Saran :</i> <br>
                                                <br>
                                                <div class="form-group">
                                                        <div class="form-line">
                                                            {{saran}}
                                                        </div>
                                                    </div>
                                              </td>
                                          </tr>

                                        </tbody>
                                    </table>
                                  </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- ============================================================ MODAL ======================================================================== -->



        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>




        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/ver_instrumen_guru/';


export default {
  name: "monev_ver_instrumen_guru",
  data() {
    return {
      data_id : '',
      soal_1 : '', soal_1_1 : '',
      soal_2 : '',
      soal_3 : '', ket_3 : '',
      soal_4 : '', ket_4 : '',
      soal_5 : '',
      soal_6 : '',
        soal_7_1 : false,
        soal_7_2 : false,
        soal_7_3 : false,
        soal_7_4 : false,
        soal_7_5 : false,
        soal_7_6 : false,
        soal_7_7 : false,
        soal_7_8 : false,
        soal_7_9 : false,
        soal_7_10 : false,
        soal_7_11 : false,
        soal_7_12 : false,
        soal_7_13 : false,
      soal_8 : '',
      soal_9 : '',
      soal_10 : '',
      soal_11 : '',

      saran : '',

      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
    };
  },

// =============================================================== METHODS =========================================================================
  methods : {
    getData : function(){
      fetch(ADD_URL+'view', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token
        },
        body : JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      }).then(res => res.json())
        .then((data_res) => {
          this.list_data = data_res.data;
          this.page_last = data_res.jml_data
          // console.log(this.list_data);
        })
    },

    viewId : function(data_id){
      this.data_id = data_id
    },

    setujuiData : function(){
      fetch(ADD_URL+'setujui', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+ localStorage.token,
        },
        body : JSON.stringify({
          data_id : this.data_id,
          saran : this.saran,
          status : 'diterima',

        })
      }).then((res_data)=>{
        this.alertku("success", "Data Sukses disetujui");
        this.getData();
      });
    },

    kembalikanData : function(){
      fetch(ADD_URL+'setujui', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+ localStorage.token,
        },
        body : JSON.stringify({
          data_id : this.data_id,
          saran : this.saran,
          status : 'dikembalikan',
        })
      }).then((res_data)=>{
        this.alertku("success", "Data Sukses disetujui");
        this.getData();
      });

    },

    viewData : function(data_cari){
      fetch(ADD_URL+'view_one', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token
        },
        body : JSON.stringify({
          data_ke: this.page_first,
          cari_value: data_cari,
        })
      }).then(res => res.json())
        .then((data_res) => {

          // console.log(data_res.data);


          if (data_res.data == null) {
            this.counter = true
          } else {
            this.counter = false
          }

          this.soal_1 = data_res.data.soal_1; this.soal_1_1 = data_res.data.soal_1_1;
          this.soal_2 = data_res.data.soal_2;
          this.soal_3 = data_res.data.soal_3; this.ket_3 = data_res.data.ket_3;
          this.soal_4 = data_res.data.soal_4; this.ket_4 = data_res.data.ket_4;
          this.soal_5 = data_res.data.soal_5;
          this.soal_6 = data_res.data.soal_6;
            this.soal_7_1 = data_res.data.soal_7_1;
            this.soal_7_2 = data_res.data.soal_7_2;
            this.soal_7_3 = data_res.data.soal_7_3;
            this.soal_7_4 = data_res.data.soal_7_4;
            this.soal_7_5 = data_res.data.soal_7_5;
            this.soal_7_6 = data_res.data.soal_7_6;
            this.soal_7_7 = data_res.data.soal_7_7;
            this.soal_7_8 = data_res.data.soal_7_8;
            this.soal_7_9 = data_res.data.soal_7_9;
            this.soal_7_10 = data_res.data.soal_7_10;
            this.soal_7_11 = data_res.data.soal_7_11;
            this.soal_7_12 = data_res.data.soal_7_12;
            this.soal_7_13 = data_res.data.soal_7_13;
          this.soal_8 = data_res.data.soal_8;
          this.soal_9 = data_res.data.soal_9;
          this.soal_10 = data_res.data.soal_10;
          this.soal_11 = data_res.data.soal_11;
          this.saran = data_res.data.saran;

        })
    },


    cekStatus : function(data){
      if(data == 'diterima'){
        return {background : '#e4ffc4'}
      }
      else if (data == 'dikembalikan') {
        return {background : '#ffcece'}
      }
    },

// ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getData();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getData();
    },

    cari_data: function() {
      this.getData();
    },
// ================== PAGINASI ====================



  },
// =============================================================== METHODS =========================================================================

  mounted() {
    this.getData();
  },
};
</script>
